// extracted by mini-css-extract-plugin
export default {"likes-block":"styles_likes-block__Yxvd4"};